interface IRoutes {
  [key: string]: string;
}

const routes: IRoutes = {
  INDEX: '/',

  // Create flow
  EDIT_TEAM_NAME: '/create/:teamGuid/team-name',
  YOUR_FUNDRAISING_CAUSE: '/create/:teamGuid/your-fundraising-cause',
  STORY: '/create/:teamGuid/story',
  TEAM_SETTINGS: '/create/:teamGuid/team-settings',
  YOUR_TEAM_PAGE: '/create/:teamGuid/your-team-page',

  // Join flow
  JOIN: '/join/:teamGuid', // TODO Only these needs fundraising data
  // With existing frp
  LINK_FUNDRAISING_PAGE: '/join/:teamGuid/link', // TODO Only these needs fundraising data
  YOU_ARE_IN_THE_TEAM: '/join/:teamGuid/you-are-in-the-team',
  // With new frp
  CAUSE: '/join/:teamGuid/cause',
  EVENTS: '/join/:teamGuid/events',
  CREATE_EVENT: '/join/:teamGuid/create-event',
  FUNDRAISING_SETTINGS: '/join/:teamGuid/fundraising-settings',
  GIFT_AID: '/join/:teamGuid/gift-aid',
  JOINED_WITH_NEW_FRP: '/join/:teamGuid/joined-with-new-frp',

  // Manage routes
  // TODO remove edit once we are sure that the last link in emails has been removed
  EDIT_TEAM: '/:pageType(edit|manage)/:teamGuid/edit-team',
  SETTINGS: '/:pageType(edit|manage)/:teamGuid/settings',
  EDIT_MEMBERS: '/:pageType(edit|manage)/:teamGuid/edit-members',
};

export default routes;

// TODO Delete all reducer, actions and selectors around mode, and tests
